"use strict";

import { createContext } from 'react';
export const BottomSheetGestureHandlersContext = /*#__PURE__*/createContext(null);
export const BottomSheetDraggableContext = /*#__PURE__*/createContext(null);
//# sourceMappingURL=gesture.js.map